import React, { useCallback, useEffect, useState } from 'react'
import Loader from '../../Loader/Loader';
import TicketsTable from './TicketsTable/TicketsTable';
import { getTicketsAPI } from '../../utils/APIs/ticketsApis';
import './Tickets.css';

const Tickets = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [ticketData, setTicketData] = useState([]);
    const [page, setPage] = useState(() => {
        const savedPage = sessionStorage.getItem("ticketsPage");
        return savedPage ? Number(savedPage) : 1;
    });
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState("");

    const LIMIT = 10;

    useEffect(() => {
        const interval = setInterval(() => {
            const stored = sessionStorage.getItem("isSidebarOpen");
            const parsed = stored !== null ? JSON.parse(stored) : true;
            if (parsed !== isSidebarOpen) {
                setIsSidebarOpen(parsed);
            }
        }, 10);
        return () => clearInterval(interval);
    }, [isSidebarOpen]);

    useEffect(() => {
        sessionStorage.setItem("ticketsPage", page);
    }, [page]);

    const fetchData = useCallback(async (pageNo = page) => {
        setLoading(true);
        try {
            const res = await getTicketsAPI(pageNo, LIMIT, statusFilter);
            if (res?.data?.success) {
                setTicketData(res.data.data || []);
                setTotal(res.data.pagination?.totalRecords || 0);
                setPage(res.data.pagination?.currentPage || pageNo);
            }
        } catch (err) {
            console.error("failed to fetch tickets", err);
        } finally {
            setLoading(false);
        }
    }, [page, statusFilter]);

    useEffect(() => {
        fetchData(page);
    }, [fetchData, page]);

    const totalPages = Math.ceil(total / LIMIT);

    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;
        let start = Math.max(1, page - 2);
        let end = Math.min(totalPages, page + 2);

        if (end - start < maxVisible - 1) {
            if (start === 1) end = Math.min(totalPages, start + maxVisible - 1);
            else if (end === totalPages) start = Math.max(1, end - maxVisible + 1);
        }

        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    };

    if (loading && ticketData.length === 0) {
        return <Loader />
    }

    return (
        <div className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`} style={{ marginTop: "100px" }}>
            <div className="my-quote-page page-inner-wrapper">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 className="page-title">Support Tickets</h2>
                    <div className="filters d-flex gap-3">
                        <select 
                            className="form-select filter-select" 
                            value={statusFilter} 
                            onChange={(e) => {
                                setStatusFilter(e.target.value);
                                setPage(1);
                            }}
                        >
                            <option value="">All Status</option>
                            <option value="open">Open</option>
                            <option value="in progress">In Progress</option>
                            <option value="closed">Closed</option>
                        </select>
                    </div>
                </div>

                <TicketsTable
                    data={ticketData}
                    page={page}
                    limit={LIMIT}
                    refreshData={() => fetchData(page)}
                />

                {totalPages > 1 && (
                    <div className="pagination mt-4">
                        <button className="pagination-btn" disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
                        {getPageNumbers().map((p) => (
                            <button key={p} className={`pagination-btn ${p === page ? "active" : ""}`} onClick={() => setPage(p)}>{p}</button>
                        ))}
                        <button className="pagination-btn" disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Tickets;
